import { SERVICE_OPTIONS_V2 } from '~/components/constants';

export const getServiceInfoFromOptions = (
  serviceTypeId: number,
  serviceType?: string,
  options = SERVICE_OPTIONS_V2
): [string, string] => {
  const service =
    options.find((option) => option.value === serviceType) ||
    options.find((option) => option.serviceTypeId === serviceTypeId) ||
    options[0];

  const serviceName = service.label;

  let serviceDescription = '';

  if (service.description) {
    serviceDescription = service.description;
  }

  return [serviceName, serviceDescription];
};
